const configuredBase = window.CONSILIA_API_URL || process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development" ? "http://127.0.0.1:8000" : "");

export const apiUrl = (path) => {
  if (!configuredBase) throw new Error("Backend URL is not configured yet.");
  return `${configuredBase.replace(/\/$/, "")}${path}`;
};
